import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const onboardingStatusAPI = createAsyncThunk('business/check', async ({ requestHeaders }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    console.log("redux",requestHeaders);
    const response = await fetch(`${ROOT_URL}/business/check/${requestHeaders}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const checkOnboardingStatus = createSlice(
  {
    name: 'onboardingStatus',
    initialState,
    reducers: {},
    extraReducers: {
      [onboardingStatusAPI.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [onboardingStatusAPI.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [onboardingStatusAPI.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default checkOnboardingStatus;
